export type RumRuntimeConfig = {
  applicationId: string;
  applicationVersion: string;
  region: string;
  endpoint: string;
  sessionSampleRate: number;
  telemetries: Array<'performance' | 'errors' | 'http'>;
  allowCookies: boolean;
  enableXRay: boolean;
  signing: boolean;
};

export function getRumRuntimeConfig(): RumRuntimeConfig | null {
  const applicationId = process.env.REACT_APP_RUM_APPLICATION_ID?.trim();
  if (!applicationId) {
    return null;
  }

  const region = process.env.REACT_APP_RUM_REGION?.trim() || 'us-west-2';

  return {
    applicationId,
    applicationVersion: process.env.REACT_APP_RUM_APPLICATION_VERSION?.trim() || '1.0.0',
    region,
    endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
    sessionSampleRate: 1,
    telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: false,
    signing: false,
  };
}
